var _circle, _path, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppliedFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 17.25,
    r: 12,
    fill: "#005587"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5833 12.25C16.741 12.25 16.8852 12.339 16.9558 12.48C17.0178 12.6036 17.0139 12.7485 16.9485 12.8674L16.9167 12.9167L13 18.25V21.25L12.0833 22.0833C11.9392 22.1917 11.7637 22.2502 11.5833 22.25L11.4494 22.2473C11.1209 22.2348 11.0154 22.169 11.0015 21.819L11 21.75V18.25L7.08334 12.9167C6.98864 12.7904 6.97341 12.6215 7.04399 12.4803C7.10575 12.3568 7.22393 12.2731 7.35824 12.2541L7.41667 12.25H16.5833ZM9.09178 13.0833H8.67511C8.5962 13.0833 8.52406 13.1279 8.48877 13.1985C8.46054 13.255 8.45977 13.3203 8.48483 13.3765L8.50844 13.4167L10.5651 16.125C10.6189 16.1967 10.7126 16.226 10.7977 16.1976C10.8706 16.1733 10.9232 16.1114 10.9367 16.0377L10.9401 16V15.4792C10.9401 15.4491 10.9336 15.4196 10.9213 15.3926L10.8984 15.3542L9.25719 13.1667C9.22593 13.125 9.18051 13.0969 9.13024 13.0871L9.09178 13.0833Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 6.75,
    r: 5,
    fill: "#C42EA5",
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliedFilter);
export default __webpack_public_path__ + "static/media/applied-filter.df37a8ad.svg";
export { ForwardRef as ReactComponent };